import React, {useState} from 'react';
import {IonButton, IonButtons, IonIcon, IonListHeader,
IonPopover, IonList, IonItem} from "@ionic/react";
import {removeCircleOutline, addOutline, checkmark, closeOutline} from "ionicons/icons";

interface AplicacaoEventoEditProps {
  produtos: any[];
  selecionados: any[];
  setProdutos: (produtos:any[]) => void;
  setCloseEdit: () => void;
}

const AplicacaoEventoEdit: React.FC<AplicacaoEventoEditProps> = (props) => {
  const [selecionados, setSelecionados] = useState(props.selecionados);
  const [addVisible, setAddVisible] = useState(false);

  const addProduto = (p:any) => {
    setSelecionados(pSel => {
      return [...pSel, p];
    });
    setAddVisible(false);
  };

  return (
    <>
      {
        selecionados.map((p: any) => (
          <div key={p.id} className="flex items-center">
            <div className="flex-grow">
              {p.nome}
            </div>
            <div>
              <IonButton
                fill="clear"
                color="danger"
                size="small"
                onClick={() => {
                  setSelecionados(pSel => {
                    return pSel.filter(i => i.id !== p.id);
                  })
                }}
              >
                <IonIcon icon={removeCircleOutline} slot="icon-only" />
              </IonButton>
            </div>
          </div>
        ))
      }
      <div>
        <IonButton
          fill="clear"
          color="medium"
          size="small"
          onClick={() => setAddVisible(true)}
        >
          <IonIcon icon={addOutline} slot="start"/>
          Adicionar produto
        </IonButton>
      </div>

      <div className="flex justify-end mt-6">
        <IonButtons>
          <IonButton
            onClick={() => {
              props.setProdutos(selecionados);
              props.setCloseEdit();
            }}
          >
            <IonIcon
              icon={checkmark}
            />
          </IonButton>
          <IonButton
            onClick={() => props.setCloseEdit()}
          >
            <IonIcon
              icon={closeOutline}
            />
          </IonButton>
        </IonButtons>

        <IonPopover
          isOpen={addVisible}
          onDidDismiss={() => setAddVisible(false)}
          className="calendario-evento-edit-popover"
        >
          <AddProduto
            produtos={props.produtos}
            setClose={() => setAddVisible(false)}
            selecionadosIds={selecionados.map(i => i.id)}
            onConfirm={addProduto}
          />
        </IonPopover>
      </div>
    </>
  );
}

export default AplicacaoEventoEdit;


interface AddProdutoProps {
  produtos: any[];
  selecionadosIds: number[];
  setClose: () => void;
  onConfirm: (produto:any) => void;
}

const AddProduto: React.FC<AddProdutoProps> = (props) => {
  return (
    <div className="flex">
      <div className="flex-grow">
        <IonList>
          <IonListHeader className="mb-4">
            Produtos
          </IonListHeader>
          {
            props.produtos.map((p: any) => (
              <IonItem
                key={p.id}
                disabled={props.selecionadosIds.indexOf(p.id) !== -1}
                button={true}
                onClick={() => props.onConfirm(p)}
              >
                {p.nome}
              </IonItem>
            ))
          }
        </IonList>
      </div>
    </div>
  );
}
